/**
 * @fileoverview Layout wrapper for help pages
 * 
 * This component provides a consistent layout structure for all help pages
 * with header, main content area, and footer.
 */

import React from 'react';
import { HelpPageHeader } from './HelpPageHeader';
import { HelpPageFooter } from './HelpPageFooter';

interface HelpPageLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const HelpPageLayout: React.FC<HelpPageLayoutProps> = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <HelpPageHeader title={title} />
      <main className="flex-1">
        {children}
      </main>
      <HelpPageFooter />
    </div>
  );
}; 